<template>
  <div class="mobile-index-box margin-top">
    <img src="../../../assets/img/mobile/mobile-index-text.png" alt="">
    <img src="../../../assets/img/mobile/mobile-index.png" alt="" >
    <div class="next-btn" @click="toNext(1)">下一页</div>
  </div>
</template>

<script>
export default {
  name: "indexPage",
  data() {
    return {}
  },
  created() {
  },
  components: {},
  methods: {
    toNext(num){
      this.$emit('toNext',num)
    }
  },
  filters: {},
  watch: {},
}
</script>

<style scoped lang="scss">
.mobile-index-box{
  min-height: calc(100vh - 150px);
  img{
    width: 100%;
    margin-bottom: 30px;
  }
  .next-btn{
    width: 50%;
    height: 40px;
    background: #fff;
    border-radius: 20px;
    text-align: center;
    line-height: 40px;
    margin: 0 auto;
    font-size: 16px;
    color: #f84e4e;
  }
}
</style>
